module.exports = __webpack_public_path__ + "img/vn.15531ca8.svg";